import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CartProvider } from "@/context/CartContext";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import CartDrawer from "@/components/feature/CartDrawer";
import MobileBottomNav from "@/components/feature/MobileBottomNav";
import FloatingWhatsAppButton from "@/components/feature/FloatingWhatsAppButton";
import FloatingScrollToTop from "@/components/feature/FloatingScrollToTop";
import ScrollToTop from "@/components/feature/ScrollToTop";
import ScrollProgressBar from "@/components/feature/ScrollProgressBar";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <CartProvider>
          <ScrollToTop />
          <ScrollProgressBar />
          <div className="min-h-screen flex flex-col pb-20 md:pb-0">
            <Header />
            <main className="flex-1">
              <AppRoutes />
            </main>
            <Footer />
            <CartDrawer />
            <MobileBottomNav />
            <FloatingWhatsAppButton />
            <FloatingScrollToTop />
          </div>
        </CartProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;